import { t } from "@/i18n-js/instance";
import type { Plan } from "@circle-react/types";
import { Typography } from "@circle-react-shared/uikit/Typography";

const localeRoot = "pricing_plans.plan_settings.plan_selection.plan_selector";

interface AnnualDiscountProps {
  plan: Plan;
}

export const AnnualDiscount = ({ plan }: AnnualDiscountProps) => {
  if (!plan.annual_discount_amount_with_currency) return null;

  return (
    <Typography.BodyXs weight="light">
      {t(`${localeRoot}.annual_amount`, {
        dollar_amount: plan.annual_base_amount_with_currency,
      })}
      <span className="text-green-success-dark ml-1 font-semibold">
        {t(`${localeRoot}.saved_dollar_amount`, {
          dollar_amount: plan.annual_discount_amount_with_currency,
        })}
      </span>
    </Typography.BodyXs>
  );
};
